import SitePageLayout from '../components/SitePageLayout';

export default function DeactivateAccountScreen() {
  return (
    <SitePageLayout title="Delete Account" effectiveDate="February 11, 2026">
      <p>
        You can request deletion of your account and associated data at any time. Follow the
        steps below or contact us if you need help.
      </p>

      <section className="legal-section">
        <h2>How to Request Deletion</h2>
        <ul>
          <li>Open Wreckoning Ball on your device and sign in.</li>
          <li>Go to Profile {'>'} Sign-in Methods.</li>
          <li>Select Delete Account and confirm.</li>
          <li>
            If you cannot access the app, email support@xerratus.com from the address tied to
            your account and we will process the request manually.
          </li>
        </ul>
      </section>

      <section className="legal-section">
        <h2>What We Delete</h2>
        <ul>
          <li>Your account and authentication records.</li>
          <li>
            Conversation data, partner relationships, custom personas, language/settings/theme
            preferences, and generated translation records tied to your account.
          </li>
          <li>App-linked invite/message records associated with your account.</li>
        </ul>
        <p>
          Deletion removes data from active systems immediately. Backups are overwritten on their
          normal cycle; once backups expire, deleted data cannot be restored.
        </p>
      </section>

      <section className="legal-section">
        <h2>What We May Retain</h2>
        <ul>
          <li>Minimal logs needed for security, fraud prevention, or legal compliance.</li>
          <li>
            Receipts or billing records we are required to keep for tax and accounting purposes.
          </li>
        </ul>
        <p>
          These retained records do not include your conversation practice content or profile
          data.
        </p>
      </section>

      <section className="legal-section">
        <h2>Export Before You Delete</h2>
        <p>
          Wreckoning Ball currently does not provide a self-serve full account export in the app. If
          you need help with records before deletion, contact support and we can assist.
        </p>
      </section>

      <section className="legal-section">
        <h2>Need Help?</h2>
        <p>
          Contact support@xerratus.com with the email tied to your account and a brief note that
          you want your data deleted. We typically complete requests within a few business days.
        </p>
      </section>
    </SitePageLayout>
  );
}
